import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import newsData from "../data/newsData";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function News() {
    const { t } = useTranslation();
    useScrollAnimation();
    const showData = newsData.map((el, index) =>
        <div key={index} className="f-col js-scroll fade-top flex shadow-[0px_0px_10px_#00000029] rounded-[8px] gap-[30px]">
            <div className="w-100 w-[40%] border-r-[3px] border-r-[#017E89]">
                <img className="rounded-l-[8px] w-full h-full" src={el.image} alt="" />
            </div>
            <div className="w-100 w-[59%] p-[20px] flex flex-col justify-between gap-[15px]">
                <div className="flex flex-col gap-[15px]">
                    <div className="capitalize font-bold text-[20px]">{t(`${el.title}`)}</div>
                    <p>{t(`${el.description.length > 50 ? el.description.substring(0, 250) + "..." : el.description}`)}</p>
                    <div className="flex items-center gap-[5px]">
                        <img className="w-[20px] h-[20px]" src={require("../../assets/icons/calender.svg").default} alt="" />
                        <div className="font-bold text-[#017E89]">{el.data}</div>
                    </div>
                </div>
                <Link to={`/newsDetails/${el.id}`}>
                    <span className="capitalize font-bold">Read More</span>
                    <img className="h-auto" src={require("../../assets/icons/twoLines.svg").default} alt="" />
                </Link>
            </div>
        </div>
    )
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("News & Event")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] fonbold">
                        <Link to={"/"}>{t("Home")}</Link>
                        -
                        <span className="text-[#017E89] capitalize">{t("News & Event")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <div className="btmAni25002 flex items-baseline gap-[7px]">
                        <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                        <div className="font-bold capitalize text-[25px] text-[#017e89]">{t("News & Event")}</div>
                    </div>
                    <div className="flex flex-col gap-[20px]">
                        {showData}
                    </div>
                </div>
            </section>
        </>
    );
}